<template>
  <v-card
    class="module-card"
    :style="{
      minHeight: expand || !mobile ? '265px' : '',
      borderLeft: mobile ? `3px solid ${themeColor}` : '',
    }"
    v-if="checkPermissionToView"
  >
    <v-card-title @click="expand = !expand" class="module-card__title">
      <div class="module-card__title__icon" :style="{ color: themeColor }">
        <i :class="`bexsicon-${icon}`" />
      </div>
      <div class="module-card__title__text">
        <v-progress-circular
          v-if="titleLoading && mobile"
          indeterminate
          class="module-card__title-loader"
        ></v-progress-circular>
        <p
          v-else
          class="module-card__title__text__title"
          :style="{ color: themeColor }"
        >
          {{ title }}
        </p>
        <v-slide-y-transition>
          <p
            v-show="expand || !mobile"
            class="module-card__title__text__description"
          >
            {{ description }}
          </p>
        </v-slide-y-transition>
      </div>
      <v-btn
        v-if="mobile"
        icon
        class="module-card__expand-btn expansion-icon-size"
        :style="{ color: themeColor }"
      >
        <i :class="expand ? 'bexsicon-minus' : 'bexsicon-plus'" />
      </v-btn>
    </v-card-title>
    <v-slide-y-transition>
      <v-card-text v-show="expand || !mobile">
        <slot v-if="!loading && !error" name="content"></slot>
        <v-progress-circular
          v-if="loading"
          indeterminate
          class="module-card__loader"
        ></v-progress-circular>
        <div v-else-if="error" class="module-card__error">
          <v-layout align-center justify-center column>
            {{ errorText }}
            <v-btn
              flat
              :color="themeColor"
              v-if="retryFunction != null"
              @click="retryFunction"
            >
              {{ $t('actions.retry') }}
            </v-btn>
          </v-layout>
        </div>
      </v-card-text>
    </v-slide-y-transition>
    <v-slide-y-transition>
      <v-card-actions v-show="expand || !mobile" class="module-card__actions">
        <slot v-if="!loading && !error" name="actions"></slot>
      </v-card-actions>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { hasPermission, hasPermittedRole } from '../../utils';
import { UNIT } from '../../utils/constants';
export default {
  name: 'module-card',
  props: {
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    description: {
      type: String,
    },
    themeColor: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    titleLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: () => [],
    },
    errorText: String,
    retryFunction: {
      type: Function,
      default: null,
    },
    segmentations: {
      type: Array,
      default: () => null,
    },
    canShow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    unitSegmentations() {
      return this.$store.getters[UNIT.GET_SEGMENTATIONS];
    },
    checkPermissionToView() {
      let _hasPermission = true;
      let _hasRole = true;
      let _hasSegmentations = true;

      if (this.permissions.length > 0) {
        _hasPermission = hasPermission(this.permissions);
      }
      if (this.roles.length > 0) {
        _hasRole = hasPermittedRole(this.roles);
      }

      const unitSegmentations = this.unitSegmentations;
      if (unitSegmentations.length > 0) {
        if (Array.isArray(this.segmentations)) {
          if (this.segmentations.length > 0) {
            _hasSegmentations = unitSegmentations.every((segmentation) =>
              this.segmentations.includes(segmentation)
            );
          }
        } else {
          // null or undefined
          _hasSegmentations = false;
        }
      } else {
        _hasSegmentations = false;
      }
      const isVisible =
        _hasPermission && _hasRole && _hasSegmentations && this.canShow;
      this.$emit('visibleChanged', isVisible);
      return isVisible;
    },
  },
  data() {
    return {
      expand: false,
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.module-card {
  max-height: 265px;
  @include breakpoint(mobile) {
    max-height: inherit;
  }

  &__expand-btn {
    font-size: 1.25em;
    margin-right: auto;
  }

  &__loader {
    margin: 20% 0;
    height: 50%;
    color: var(--brand-color);
    width: 100% !important;
  }

  &__title-loader {
    color: var(--brand-color);
  }

  &__error {
    padding: 1em;
    font-size: 0.9em;
    font-weight: 500;
  }

  &__actions {
    padding: 8px 16px !important;
    padding-bottom: 15px;
    position: absolute;
    bottom: 0;

    >>> .v-btn {
      padding: 0 10px !important;
    }
  }

  &__title {
    display: flex;
    padding: 16px 16px 0 16px;
    @include breakpoint(mobile) {
      padding: 16px;
    }

    &__icon {
      flex: 0.2;
      font-size: 2.5em;
      margin-top: 10px;
      margin-left: 6px;
    }

    &__text {
      padding-top: 0;
      flex: 0.8;

      &__title {
        font-size: 1.2em;
        margin: 0;
      }

      &__description {
        font-size: 0.75em;
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/layout/Card.vue